import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const isDevModeAtom = atomWithStorage<boolean>("DEVMODE", false);

export const useIsDevMode = () => {
  const [isDevMode, setIsDevMode] = useAtom(isDevModeAtom);

  return {
    isDevMode,
    setIsDevMode,
  };
};
